import React from "react"
import ReactDOM from "react-dom/client"
import * as Sentry from "@sentry/react"
import App from "./App"
import "../styles/globals.css"

const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN
const sentryEnv = process.env.NEXT_PUBLIC_SENTRY_ENV || "stable"

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnv,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

const rootElement = document.getElementById("root")

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
